import React from "react";
import "../Styles/about1.css";
import Pic from '../Pic.jpeg';
import { Accordion, AccordionItem } from "@nextui-org/react";

const About = () => {

  
    return (
        <div className="about-1" id="about">


            <div className="a-1">
                <h1 className=" a1-1" style={{ paddingTop: '5%', paddingLeft: '5%', textAlign: "left" }}> The first web3 crypto platform</h1>
                <div>
                    <h3 className="a1-2" style={{ paddingLeft: '5%', fontSize: '30px', fontWeight: "bold", marginTop: '30px' }}>Problem</h3>
                    <p style={{ paddingLeft: '5%', paddingRight: '10%', paddingBottom:'50px',lineHeight:'25px', marginTop: '20px', color:'#737373' }} className="font-gothica1 font-[400] text-[16px]">Today, even in alpha communities, there's an enormous volume of information that members have to wade through for 6-8+ hours a day. Cutting through the noise of spam is a real problem even where there's something genuinely worth knowing.</p>
                    
                    <Accordion  variant="splitted" className="accor"  defaultExpandedKeys={["2"]}  style={{ paddingLeft:'100px',paddingRight:'100px'}}>
                        <AccordionItem key="1" aria-label="Accordion 1" subtitle="Crypto infonoise" title="Problem" style={{fontWeight:'800',fontSize:'30px',marginBottom:'10px'}}>
                            <img className="pi-1" src={Pic} alt="Pic" />
                            <br></br>
                            <p style={{fontSize:'30px', fontWeight:'500px'}}>The first web3 crypto platform</p>
                            <p style={{fontSize:'20px',fontWeight:100,color:'#737373'}}> "In today's cryptospace there is a big problem of Anyone getting into crypto and trying to find worthwhile activities or alpha projects in it encounters a huge amount of information that they have to filter daily."</p>
                            <br></br>
                            
                        </AccordionItem>
                        
                        <AccordionItem key="3" aria-label="Accordion 1" subtitle="NDF platfrom" title="Solution" style={{fontWeight:'800',fontSize:'30px'}}>
                            <img className="pi-1" src={Pic} alt="Pic" />
                            <br></br>
                            <p style={{fontSize:'30px', fontWeight:'500px'}}>We work to make your life easier</p>
                            <p style={{fontSize:'20px',fontWeight:100,color:'#737373'}}> "With NFD you will be able to participate only in the most selected activities, thanks to which you can quickly understand crypto and earn money. Also with the help of our Aggregator you will be able to track all the necessary information on the projects you are interested in in one place."</p>
                            <br></br>
                            
                        </AccordionItem>
                    </Accordion>
                </div>

            </div>
            <div className="a-2">
                <img className="picc-1" src={Pic} alt="Pic" />
            </div>


        </div>
    );
};

export default About;


